import React from 'react'

export default function Availability() {
  return (
    <div>Availability</div>
  )
}
